import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik, useFormikContext} from "formik";
import s from "./BankTransferFormPersonal.module.css";
import {Popover} from "antd";
import info from "../../assets/img/personalAccount/information.svg";
import CustomDropdown from "../ui/CustomDropdown/CustomDropdown";
import MyInput from "../ui/MyInput/MyInput";
import classnames from "classnames";
import MyBtn from "../ui/MyBtn/MyBtn";
import {motion} from "framer-motion";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import CustomDropdownForAccounts from "../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import {typesList} from "../../Constants/StaticData"
import {
    CurrencyHelper,
    PaymentTypeHelper,
    getValidationSchema, SwiftCheckerHelper
} from "./FormHelpers/FormHelpers";
import {useSelector} from "react-redux";
import {selectAccountsByFilter} from "../../store/reducers/TransactionsSlice/selector";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import DomesticEur from "./FieldsForPaymentTypes/DomesticEur";
import InternationalEur from "./FieldsForPaymentTypes/InternationalEur";
import DomesticGbp from "./FieldsForPaymentTypes/DomesticGbp";
import InternationalGbp from "./FieldsForPaymentTypes/InternationalGbp";
import CustomCheckbox from "../ui/customCheckbox/CustomCheckbox";
import {checkVopStatusThunk, getChallengeDataThunk, getFeesForTransaction} from '../../store/reducers/ActionCreators';
import CustomModal from '../ui/CustomModal/CustomModal';
import {FormikPersist} from "./FormHelpers/FormikPersist";
import {clearFormByChangeType} from "../../helpers/clearFormHelper";
import {PrepareDataForBankTransaction} from "../../helpers/prepareDataForTransactions/PrepareDataForTranzactions";
import styles from "../../styles/styles.module.css";
import iconInfo from "../../assets/img/personalAccount/info-circle.svg";
import {setIsLoading} from "../../store/reducers/UserSlice";
import {setTransferDataPreview} from "../../store/reducers/TransactionsSlice/TransactionsSlice";
import {useNavigate} from "react-router-dom";
import AddDoc from "../AddDoc/AddDoc";

type PropsType = {
    setCurrent?: Dispatch<SetStateAction<number>>
    id?: string | number;
    isButtonDisable: boolean | undefined
}

export type vopStatusDataType = {
    firstName: string | undefined,
    lastName: string | undefined,
    companyName: string | undefined,
    ibanCode: string | undefined,
    swiftCode: string | undefined
}

const AutoSetPaymentTypeHelper: React.FC<{ currency: string, payerAccount: string }> = ({currency, payerAccount}) => {

    const {setFieldValue, values} = useFormikContext();

    const stringifiedValue = sessionStorage.getItem('transfer-form')

    const presavedData = JSON.parse(String(stringifiedValue))

    useEffect(() => {

        if (presavedData?.values?.payerAccount && presavedData?.values?.payerAccount === payerAccount) {
            return
        }

        if (currency === 'GBP') {
            setFieldValue('paymentRegions', '');
        }
        if (currency === 'EUR') {
            setFieldValue('paymentRegions', '');
        }
    }, [currency, setFieldValue]);

    return null;
};

const BankTransferFormPersonal = (props: PropsType) => {

    const [paymentRegion, setPaymentRegion] = useState("")
    const [accountNumber, setAccountNumber] = useState("")
    const [isIbanWrong, setIsIbanWrong] = useState(false)
    const [selectedOptionRecipientType, setSelectedOptionRecipientType] = useState("INDIVIDUAL")
    const [currency, setCurrency] = useState('')
    const [isDocumentErrorModalOpen, setIsDocumentErrorModalOpen] = useState<boolean | null>(false)
    const [documentErrorModalText, setDocumentErrorModalText] = useState<string | null>('')
    const [isThisFirstCheck, setIsThisFirstCheck] = useState<boolean | null>(true)
    const [isLimitPopupOpen, setIsLimitPopupOpen] = useState<boolean | null>(false)
    const [limitType, setLimitType] = useState<string | null>('');
    const [vopErrorText, setVopErrorText] = useState<string | null>('')
    const [isVopError, setIsVopError] = useState<boolean | null>(false)
    const [isVopSuccess, setIsVopSuccess] = useState<boolean | null>(false)
    const navigate = useNavigate()

    const token = useAppSelector(state => state.userReducer.userToken)

    const dispatch = useAppDispatch()

    const [isMobile, setIsMobile] = useState(false)

    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)

    const [isNotEnoughMoney, setIsNotEnoughMoney] = useState<boolean | null>(false)

    const accountsList = useSelector(selectAccountsByFilter)

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [window.innerWidth])

    useEffect(() => {
        if (!accountNumber) {
            return
        }
        sessionStorage.setItem("accountNumber", accountNumber)
    }, [accountNumber])

    useEffect(() => {
        const accNumber = sessionStorage.getItem("accountNumber")
        if (accNumber) {
            setAccountNumber(accNumber)
        }
    }, [])

    const [paymentRegionOptions, setPaymentRegionOptions] = useState(typesList)

    useEffect(() => {
        if (currency === 'EUR') {
            setPaymentRegionOptions(['SEPA', 'international']);
        } else if (currency !== 'EUR') {
            setPaymentRegionOptions(typesList);
        }
    }, [currency]);

    const getFees = async (obj: any) => {

        const preparedData = PrepareDataForBankTransaction(obj)
        const resp = await dispatch(getFeesForTransaction(token, preparedData))

        return resp
    }

    const checkVopStatus = async (data: vopStatusDataType) => {
        return await dispatch(checkVopStatusThunk(token, data))
    }

    const getChallengeData = async (obj: any) => {
        const preparedData = PrepareDataForBankTransaction(obj)

        const resp = await dispatch(getChallengeDataThunk(token, {transaction: preparedData}))

        return resp
    }

    const onKeyDown = (e: any) => {

        const allowed = /^[A-Za-z0-9\/\-?:().,'+ ]$/;

        if (e.key.length === 1 && !allowed.test(e.key)) {
            e.preventDefault();
        }
    }

    return (
        <div data-testid="bank-transfer-form">
            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >

                <CustomModal type="error" isNotify isModalOpen={isNotEnoughMoney} setIsModalOpen={setIsNotEnoughMoney}>
                    <div className={s.modal_content}>
                        <div className={s.popup_subtitle}>
                            <span className={s.error}>Failed!</span> The transfer cannot be made due to insufficient
                            funds.
                        </div>
                        <div className={s.popup_button_block}>
                            <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                                   onClick={() => setIsNotEnoughMoney(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModal type="error" isNotify isModalOpen={isDocumentErrorModalOpen}
                             setIsModalOpen={setIsDocumentErrorModalOpen}>
                    <div className={s.modal_content}>
                        <div className={s.popup_subtitle}>
                            <span className={s.error}>Failed!</span> {documentErrorModalText}
                        </div>
                        <div className={s.popup_button_block}>
                            <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                                   onClick={() => setIsDocumentErrorModalOpen(null)}/>
                        </div>
                    </div>
                </CustomModal>


                <CustomModal data-testid="send-transfer-error-popup" type="error" isNotify
                             isModalOpen={isLimitPopupOpen} setIsModalOpen={setIsLimitPopupOpen}>
                    <div className={s.modal_content}>
                        <div className={s.popup_subtitle}>
                            <span className={s.error}>Failed!</span> The transaction is impossible due to
                            exceeding {limitType} limit.
                            Please contact <a className={s.popup_link}
                                              href='mailto:support@luxpay.lt'>support@luxpay.lt</a>&nbsp;
                            if you have any questions.
                        </div>
                        <div className={s.popup_button_block}>
                            <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                                   onClick={() => setIsLimitPopupOpen(false)}/>
                        </div>
                    </div>
                </CustomModal>

                <Formik
                    initialValues={{
                        name: '',
                        surname: '',
                        companyName: '',
                        recipientsIban: '',
                        recipientsSwiftBic: '',
                        reference: '',
                        recipientsAddress: '',
                        recipientCity: '',
                        recipientPostCode: '',
                        recipientCountry: '',
                        bankName: '',
                        bankAddress: '',
                        bankCity: '',
                        bankPostCode: '',
                        bankCountry: '',
                        recipientsAccountNumber: '',
                        achRoutingNumber: '',
                        fedwireRoutingNumber: '',
                        sortCode: '',
                        paymentRegions: '',
                        payerAccount: '',
                        amount: '',
                        templateName: '',
                        invoice: {
                            name: '',
                            data: ''
                        },
                        recipientType: "INDIVIDUAL",
                        type: 'international',
                    }}
                    validationSchema={getValidationSchema(paymentRegion, currency)}
                    validateOnMount={true}
                    onSubmit={async (values, formikHelpers) => {

                        dispatch(setIsLoading(true))

                        if (isIbanWrong) {
                            dispatch(setIsLoading(false))
                            return
                        }

                        let tempData = {
                            ...values,
                            accountId: accountId,
                            hiddenAccountNumberFrom: accountNumber,
                            transferCurrency: currency
                        };
                        try {

                            if (isThisFirstCheck && paymentRegion === 'SEPA') {
                                const res = await checkVopStatus({
                                    firstName: values.name,
                                    lastName: values.surname,
                                    companyName: values.companyName,
                                    ibanCode: values.recipientsIban,
                                    swiftCode: values.recipientsSwiftBic
                                })

                                if (res.matchedStatus === 'CMTC') {
                                    dispatch(setIsLoading(false))
                                    setIsVopError(true)
                                    setVopErrorText(`The payee name partially matches the account holder details.
                                    Please review the payee information before proceeding.`)
                                    return
                                } else if (res.matchedStatus === 'NMTC') {
                                    dispatch(setIsLoading(false))
                                    setIsVopError(true)
                                    setVopErrorText(`The payee name does not match the account holder details.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                    return
                                } else if (res.matchedStatus === 'NOAP') {
                                    dispatch(setIsLoading(false))
                                    setIsVopError(true)
                                    setVopErrorText(`The payee details could not be verified at this time.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                    return
                                } else if (res?.response?.status === 500) {
                                    dispatch(setIsLoading(false))
                                    setIsVopError(true)
                                    setVopErrorText(`Recipient name or surname does not match with Iban owner data. Do you want to continue?`)
                                    return
                                } else if (res?.response?.data === "API Vop validation failed") {
                                    dispatch(setIsLoading(false))
                                    setIsVopError(true)
                                    setVopErrorText(`The payee details could not be verified at this time.
                                    Proceeding may result in funds being sent to an unintended recipient.`)
                                    return
                                } else if (res?.matchedStatus === "MTCH") {
                                    dispatch(setIsLoading(false))
                                    setIsVopSuccess(true)
                                    return
                                }

                                setIsThisFirstCheck(false)

                            }

                            const feesData = await getFees(tempData)

                            const challengeData = await getChallengeData(tempData)

                            dispatch(setTransferDataPreview({
                                ...tempData,
                                fee: feesData.data.fee,
                                totalAmount: feesData.data.totalAmount,
                                challengeData: challengeData.data
                            }))

                            navigate('transfer-data-preview')
                        } catch (e: any) {
                            dispatch(setIsLoading(false))

                            if (e.response.data === 'Invalid Iban') {
                                setIsDocumentErrorModalOpen(true)
                                setDocumentErrorModalText('Invalid IBAN. Please check the number and try again')
                            }

                            if (e.response.data === 'Not enough money to create transaction') {
                                setIsNotEnoughMoney(true)
                                setIsThisFirstCheck(true)
                            }

                            if (e.response.data === 'Canceling transaction because user has debts') {
                                setIsDocumentErrorModalOpen(true)
                                setDocumentErrorModalText('Canceling transaction because user has debts')
                            }

                            if (e.response.data === 'Daily Limit') {
                                setIsVopError(false)
                                setLimitType("daily")
                                setIsLimitPopupOpen(true)
                                return
                            }

                            if (e.response.data === 'Monthly Limit') {
                                setIsVopError(false)
                                setLimitType("monthly")
                                setIsLimitPopupOpen(true)
                                return
                            }
                        }
                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          setFieldValue,
                          handleChange,
                          handleSubmit,
                          setValues,
                      }) => (

                        <form onSubmit={handleSubmit}>
                            {/*<AutoSetPaymentTypeHelper currency={currency}/>*/}

                            <CustomModal type="confirm" isNotify isModalOpen={isVopSuccess}
                                         setIsModalOpen={setIsDocumentErrorModalOpen}>
                                <div className={s.modal_content}>
                                    <div className={s.popup_subtitle}>
                                        <span className={styles.success}>Success!</span> Verification of payee passed successfully
                                    </div>
                                    <div className={s.popup_button_block}>
                                        <MyBtn isPersonalAccountBtn title={"Ok"}
                                               onClick={() => {
                                                   setIsVopSuccess(false)
                                                   setIsThisFirstCheck(false)
                                                   handleSubmit()
                                               }}
                                        />
                                    </div>
                                </div>
                            </CustomModal>

                            <CustomModal type="info" isModalOpen={isVopError}
                                         setIsModalOpen={setIsVopError}>
                                <div className={styles.popup_content}>
                                    <img src={iconInfo} alt="" className={styles.img_block}/>
                                    <div className={styles.popup_title}>
                                        Attention
                                    </div>
                                    <div className={styles.popup_subtitle}>
                                        {vopErrorText}
                                    </div>
                                    <div className={styles.popup_button_wrapper}>
                                        <div className={styles.button_full_width}>
                                            <TransparentButton
                                                title={"Cancel"}
                                                isPersonalAccountBtn
                                                buttonType={"info"}
                                                medium
                                                onClick={() => setIsVopError(false)}
                                            />
                                        </div>
                                        <div className={styles.button_full_width}>
                                            <MyBtn
                                                title={"Confirm"}
                                                isPersonalAccountBtn
                                                buttonType={"info"}
                                                onClick={() => {
                                                    setIsThisFirstCheck(false)
                                                    setIsVopError(false)
                                                    handleSubmit()
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </CustomModal>

                            <div className={s.row}>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        <span className={s.labelAccount}><span className={s.red}>*</span> Payer account</span>

                                        <Popover content={"Please select the account you wish to make a transfer from."}
                                                 color={'#EEEFEF'}
                                                 overlayInnerStyle={{
                                                     fontFamily: 'Manrope',
                                                     width: '280px',
                                                     padding: '13px 16px',
                                                     cursor: 'pointer',
                                                     backgroundColor: '#E7F0EC'
                                                 }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>

                                    <CustomDropdownForAccounts
                                        items={accountsList}
                                        placeholder={"Please select the account"}
                                        id="payerAccount"
                                        name="payerAccount"
                                        isError={errors.payerAccount}
                                        touched={touched.payerAccount}
                                        setCurrency={(selectedCurrency) => {
                                            setCurrency(selectedCurrency);
                                        }}
                                        setAccountNumber={setAccountNumber}
                                    />

                                    {errors.payerAccount && touched.payerAccount &&
                                        <div className={s.error_message}>{errors.payerAccount}</div>}
                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        <span className={s.labelAccount}><span
                                            className={s.red}>*</span> Payment type</span>
                                    </div>
                                    <CustomDropdown
                                        customId="paymentRegions"
                                        items={paymentRegionOptions}
                                        placeholder={"Please select the payment type"}
                                        id="paymentRegions"
                                        name="paymentRegions"
                                        disable={!values.payerAccount}
                                        isError={errors.paymentRegions}
                                        touched={touched.paymentRegions}
                                        setItem={(value: any) => {
                                            clearFormByChangeType(values, setValues, ["payerAccount", "recipientType", "type"])
                                            setPaymentRegion(value);
                                            setFieldValue('paymentRegions', value);
                                        }}
                                    />
                                    {errors.paymentRegions && touched.paymentRegions &&
                                        <div className={s.error_message}>{errors.paymentRegions}</div>}
                                </div>

                            </div>

                            <div className={s.block}>

                                {
                                    values.paymentRegions !== "" && currency !== "" &&
                                    <div>
                                        <div className={s.title}>
                                            Outgoing Payment Details
                                        </div>
                                        <div className={classnames(s.input_block, s.recipient_type_block)}>
                                            <div className={s.input_label}>
                                                <span>RECIPIENT TYPE</span>
                                            </div>
                                            <div className={s.flex_label}>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {

                                                            clearFormByChangeType(values, setValues, ["payerAccount", "paymentRegions", "recipientType", "type"])
                                                            setSelectedOptionRecipientType(
                                                                "INDIVIDUAL"
                                                            );
                                                            setFieldValue(
                                                                "companyName",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "recipientType",
                                                                "INDIVIDUAL"
                                                            );


                                                        }}
                                                        id="INDIVIDUAL"
                                                        name="INDIVIDUAL"
                                                        isChecked={
                                                            selectedOptionRecipientType ===
                                                            "INDIVIDUAL"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            selectedOptionRecipientType ===
                                                            "INDIVIDUAL"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        INDIVIDUAL
                                                    </span>
                                                </label>
                                                <label className={s.flex_label}>
                                                    <CustomCheckbox
                                                        handleChange={() => {
                                                            clearFormByChangeType(values, setValues, ["payerAccount", "paymentRegions", "recipientType", "type"])
                                                            setSelectedOptionRecipientType(
                                                                "BUSINESS"
                                                            );
                                                            setFieldValue(
                                                                "name",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "surname",
                                                                ""
                                                            );
                                                            setFieldValue(
                                                                "recipientType",
                                                                "BUSINESS"
                                                            );
                                                        }}
                                                        id="BUSINESS"
                                                        name="BUSINESS"
                                                        isChecked={
                                                            selectedOptionRecipientType ===
                                                            "BUSINESS"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            selectedOptionRecipientType ===
                                                            "BUSINESS"
                                                                ? s.type_of_payment_active
                                                                : s.type_of_payment_inactive
                                                        }
                                                    >
                                                        BUSINESS
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                }

                                {/*Sepa (for EUR)*/}
                                {
                                    values.paymentRegions === "SEPA" && currency === "EUR" &&
                                    <DomesticEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        onKeyDown={onKeyDown}
                                    />
                                }

                                {/*International (for EUR)*/}
                                {
                                    values.paymentRegions === "international" && currency === "EUR" &&
                                    <InternationalEur
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        onKeyDown={onKeyDown}
                                    />
                                }

                                {/*Domestic (for GBP)*/}
                                {
                                    values.paymentRegions === "domestic" && currency === "GBP" &&
                                    <DomesticGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        onKeyDown={onKeyDown}
                                    />
                                }

                                {/*International (for GBP)*/}
                                {
                                    values.paymentRegions === "international" && currency === "GBP" &&
                                    <InternationalGbp
                                        values={values}
                                        currency={currency}
                                        touched={touched}
                                        errors={errors}
                                        handleChange={handleChange}
                                        isIbanWrong={isIbanWrong}
                                        onKeyDown={onKeyDown}
                                    />
                                }

                                {/*ACH (for USD)*/}
                                {/*{*/}
                                {/*    values.paymentRegions === "ACH" && currency === "USD" &&*/}
                                {/*    <AchUsd*/}
                                {/*        values={values}*/}
                                {/*        currency={currency}*/}
                                {/*        touched={touched}*/}
                                {/*        errors={errors}*/}
                                {/*        handleChange={handleChange}*/}
                                {/*        isIbanWrong={isIbanWrong}*/}
                                {/*    />*/}
                                {/*}*/}

                                {/*SWIFT (for USD)*/}
                                {/*{*/}
                                {/*    values.paymentRegions === "SWIFT" && currency === "USD" &&*/}
                                {/*    <SwiftUsd*/}
                                {/*        values={values}*/}
                                {/*        currency={currency}*/}
                                {/*        touched={touched}*/}
                                {/*        errors={errors}*/}
                                {/*        handleChange={handleChange}*/}
                                {/*        isIbanWrong={isIbanWrong}*/}
                                {/*    />*/}
                                {/*}*/}

                                {/*Fedwire (for USD)*/}
                                {/*{*/}
                                {/*    values.paymentRegions === "Fedwire" && currency === "USD" &&*/}
                                {/*    <UsdFedwire*/}
                                {/*        values={values}*/}
                                {/*        currency={currency}*/}
                                {/*        touched={touched}*/}
                                {/*        errors={errors}*/}
                                {/*        handleChange={handleChange}*/}
                                {/*        isIbanWrong={isIbanWrong}*/}
                                {/*    />*/}
                                {/*}*/}

                                {
                                    values.paymentRegions !== "" && currency !== "" &&
                                    <div className={s.mobile_amount_row}>
                                        <div className={classnames(s.input_block, s.short)}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> Amount</span>
                                                <Popover
                                                    content={"Select a currency and enter the transfer amount.\n" +
                                                        "In the account balance in the selected currency is insufficient, the system " +
                                                        "will automatically offer you to top up using funds in a different currency " +
                                                        "you have on the account."}
                                                    color={'#EEEFEF'}
                                                    overlayInnerStyle={{
                                                        fontFamily: 'Manrope',
                                                        width: '280px',
                                                        padding: '13px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#E7F0EC'
                                                    }}
                                                >
                                                    <img src={info} alt=""/>
                                                </Popover>
                                            </div>
                                            <MyInput id={"amount"}
                                                     name={"amount"}
                                                     touched={touched.amount}
                                                     value={values.amount}
                                                     onChange={handleChange}
                                                     isError={touched.amount && !!errors.amount}
                                            />
                                            {errors.amount && touched.amount &&
                                                <div
                                                    className={classnames(s.error_message, s.error_amount)}>{`${errors.amount}`}</div>}
                                        </div>

                                        <div className={s.currency_dropdown}>
                                            <MyInput
                                                id="transferCurrency"
                                                name="transferCurrency"
                                                value={currency}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>

                            {!props.id && <div className={s.block}>
                                <div className={s.title}>
                                    Save the Transfer Details as a Template
                                </div>

                                <div className={s.row}>
                                    <div className={s.input_block}>
                                        <div className={s.input_label}>
                                            template Name
                                            <Popover
                                                content={"In order to save this transfer as a template, please enter the " +
                                                    "template name."}
                                                color={'#EEEFEF'}
                                                overlayInnerStyle={{
                                                    fontFamily: 'Manrope',
                                                    width: '280px',
                                                    padding: '13px 16px',
                                                    backgroundColor: '#E7F0EC',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <img src={info} alt=""/>
                                            </Popover>
                                        </div>
                                        <MyInput id={"templateName"}
                                                 name={"templateName"}
                                                 touched={touched.templateName}
                                                 value={values.templateName}
                                                 onChange={handleChange}
                                        />
                                        {errors.templateName && touched.templateName &&
                                            <div className={s.error_message}>{errors.templateName}</div>}
                                    </div>

                                    <div className={s.input_block}>
                                    </div>
                                </div>
                            </div>}

                            <AddDoc
                                invoice={values.invoice}
                                setIsDocumentErrorModalOpen={setIsDocumentErrorModalOpen}
                                setDocumentErrorModalText={setDocumentErrorModalText}
                                setFieldValue={setFieldValue}
                            />

                            <div className={s.continue_block}>
                                <div className={s.required}>
                                    <div>
                                        <span><span className={s.red}>*</span> required fields.</span>
                                    </div>
                                    <div>
                                        <span><span className={s.red}>*</span><span className={s.red}>*</span> one of the two fields is required.</span>
                                    </div>
                                </div>
                                {!props.id && <div className={s.button_wrapper}>
                                    <MyBtn
                                        title={"Continue"}
                                        large
                                        type={"submit"}
                                        isPersonalAccountBtn
                                        localDisable={props.isButtonDisable}
                                    />

                                </div>}
                            </div>

                            <CurrencyHelper
                                accountsList={accountsList}
                                payerAccount={values.payerAccount}
                                setCurrency={setCurrency}
                                setAccountNumber={setAccountNumber}
                                values={values}
                                setPaymentRegion={setPaymentRegion}
                                hiddenAccNumber={accountNumber}
                            />

                            <SwiftCheckerHelper
                                setFieldValue={setFieldValue}
                                setIsIbanWrong={setIsIbanWrong}
                                isAdditionalFields
                                currency={currency}
                            />

                            {/*<ResetFormHelper accountNumber={accountNumber}/>*/}

                            <AutoSetPaymentTypeHelper currency={currency} payerAccount={values.payerAccount}/>

                            <PaymentTypeHelper name={"paymentType"}/>

                            <FormikPersist name="transfer-form"
                                           setSelectedOptionRecipientType={setSelectedOptionRecipientType}/>

                        </form>
                    )}
                </Formik>
            </motion.div>
        </div>
    );
};

export default BankTransferFormPersonal;
